import {
  Button, Card, CardContent, Grid,
} from '@mui/material';
import React from 'react';

import { getGemsValue } from '@gamiphy/bl/reward';
import { WelcomeReward } from '@gamiphy/loyalty-station-desktop/components/welcomeGift/reward';
import { DiscountStore } from '@gamiphy/loyalty-station-desktop/store/reward/discount';
import { Tabs, UiStore } from '@gamiphy/loyalty-station-desktop/store/ui';
import { WelcomeGiftStore } from '@gamiphy/loyalty-station-desktop/store/welcomeGift';
import { Trans, useTranslation } from '@gamiphy/react-i18n';
import { formatCash } from '@gamiphy/utils/currency';

const WelcomePointsCard: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Card>
      <CardContent>
        <Grid container direction="column" spacing={1}>
          <Grid>
            <Grid container justifyContent="space-between" alignItems="center">
              <Grid sx={{ width: '100%' }}>
                <Trans
                  i18nKey="shared.welcomePoints"
                  defaults="Welcome points"
                />
              </Grid>
              <Grid sx={{ width: '100%' }}>
                <WelcomeReward />
              </Grid>
            </Grid>
          </Grid>
          <Grid>
            {t('welcomeGift.points.description', {
              defaultValue: 'Your welcome points have a value of {{value}}',
              value: formatCash(getGemsValue(WelcomeGiftStore.total, DiscountStore.appDiscount)),
            })}
          </Grid>
          <Grid>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={() => {
                UiStore.closePage();
                UiStore.setTab(Tabs.Redeem);
              }}
            >
              {t('welcomeGift.points.cta', 'Redeem {{, gems}}')}
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default WelcomePointsCard;
